import React, { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProposals } from '../../../providers/ProposalProvider';
import { ProposalForm } from '../create/ProposalForm/ProposalForm';
import {useAuth} from "../../../providers/AuthenticationProvider";
import {useNavigate} from "react-router";
const WEB_PAGE = 'Proposals';

export const ProposalEdit = () => {
    const { checkAuth, getUserType } = useAuth();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [proposalData, setProposalData] = useState(null);
    const { getProposalById } = useProposals();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        getProposalById(id)
            .then(data => {
                setProposalData(data.data);
                setLoading(false);
            })
    }, [id, getProposalById]);

    return (
        <ProposalForm data={proposalData} proposalId={id} loading={loading} />
    );
};
